/* unplugin-vue-components disabled */import script from "./SearchDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchDescription.vue?vue&type=script&setup=true&lang=js"

import "./SearchDescription.vue?vue&type=style&index=0&id=6c52e38a&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c52e38a"]])

export default __exports__